export default "__VITE_ASSET__1midx$Eg__"